import { post } from '@/libs/http';
import { CompleteRegistrationReq, CompleteRegistrationRes } from "@/types/api/user-auth/complete-registration.d";
import { createApiMutationHook } from '@/hooks/use-api-mutation';

export const completeRegistration = ({
  params,
}: {
  params: CompleteRegistrationReq;
}) => {
  return post<CompleteRegistrationRes>('/user/auth/v1/completeRegistration', params);
};

export const UseCompleteRegistration = createApiMutationHook(completeRegistration);